export default __webpack_public_path__ + "static/icons.light-1c623186be1fc6215d0a026c550307d0bf14b118cceed4c7d8d6e47962a632dc.png";